module.exports = __webpack_public_path__ + "0529d345a0f4b1b9a17ca4c24aaf669d.svg";